<template>
  <img class="img" :src="img" @click="ImagePreview" />
</template>

<script>
export default {
  props: {
    img: {
      type: Object
    }
  },
  methods: {
    ImagePreview(e) {
      this.$appImagePriview({
        images: [e.target.src],
        closeable: true,
        showIndex: false
      });
    }
  }
};
</script>

<style scoped>
.img {
  width: 100%;
  height: 100%;
}
</style>
